// extracted by mini-css-extract-plugin
module.exports = {"service-list":"ServiceList_service-list__ue_WN","service-item":"ServiceList_service-item__epFx4","dot-black":"ServiceList_dot-black__1kl2J"};